import { axios } from '@/utils/axios';

/**
 * ANCHOR 取得列表
 */
export const getEventList = async () => {
  return axios.get('/api/event');
};

/**
 * ANCHOR 取得單筆資料
 */
export const getSingleEventList = async (id: number) => {
  return axios.get(`/api/event/${id}`);
};

/**
 * ANCHOR 查詢是否有存在的deal
 */
export const getExistDeal = async () => {
  return axios.get('/api/deal/index');
};

/**
 * ANCHOR 新增event
 */
export const storeEvent = async (data: EventFormFields) => {
  return axios.post('/api/event', data);
};

/**
 * ANCHOR 產生meeting link
 */
export const generateLink = async () => {
  return axios.get('/api/meeting/create-bbb');
};

/** Only save an event after the meeting provider returned a usable identifier. */
export const createMeetingId = async (): Promise<string> => {
  const response = await generateLink();
  const meetingId = response.data?.data?.meetingID;
  if (!response.data?.success || typeof meetingId !== 'string' || !meetingId.trim()) {
    const error = new Error('meeting_create_unavailable') as Error & { response?: unknown };
    error.response = { status: response.status, data: response.data };
    throw error;
  }
  return meetingId;
};

export const createEventMeeting = (eventId: number) =>
  axios.post<{ success: boolean; data: { meetingID: string } }>(`/api/event/${eventId}/meeting`);

/**
 * ANCHOR 取得meeting細節
 */
export const getMeetingDetail = async (meetingID: string) => {
  return axios.get(`/api/meeting/getMeetingInfo?meetingID=${meetingID}`);
};

/**
 * ANCHOR 更新event
 */
export type UpdateEventFields = Pick<EventFormFields,
  'evt_name' | 'evt_startDate' | 'evt_endDate' | 'evt_note' | 'evt_dl_id' | 'evt_guest_id'>;

export const updateEvent = async (id: number, data: UpdateEventFields) => {
  return axios.put(`/api/event/${id}`, data);
};

/**
 * ANCHOR 刪除event
 */
export const destroyEvent = async (id: number) => {
  return axios.delete(`/api/event/${id}`);
};

/**
 * ANCHOR 建立正確會議連結
 */
export const joinMeeting = async (params: string) => {
  return axios.get(`/api/meeting/join-bbb?${params}`);
}

/**
 * ANCHOR 建立正確會議連結給未登入者
 */
export const joinMeetingForGuest = async (meeting_id: string, locale?: string) => {
  return axios.get(`/api/join-meeting/${meeting_id}`, { params: locale ? { locale } : undefined });
}

/**
 * ANCHOR 確認會議的狀態 (後端處理其餘事項)
 */
// export const checkMeetingIsRunning = async(meeting_id: string) => {
//   return axios.get(`/api/meeting/checkMeetingIsRunning?meetingID=${meeting_id}`);
// }

/**
 * ANCHOR 取得使用者的會議影片紀錄
 */
export const getUserMeetingRecordings = async () => {
  return axios.get('/api/meeting/getRecordSize');
}

/**
 * ANCHOR 刪除指定的會議影片紀錄
 */
export const deleteUserMeetingRecordings = async (recordID: string) => {
  return axios.post('/api/meeting/deleteRecord', { recordID });
}
